export const valueNoMask = (value: string) => {
	return typeof value === 'string' ? value.replace(/[^\d]/g, '') : null;
}
